import { ApproveTimeLogIconSVG } from "../../../../assets/SVGs/ApproveTimeLogIconSVG";
import { DeleteIconSVG } from "../../../../assets/SVGs/DeleteIconSVG";
import { EditButtonSVG } from "../../../../assets/SVGs/EditButtonSVG";
import { RejectTimeLogIconSVG } from "../../../../assets/SVGs/rejectTimeLogIconSVG";
import { RevokeIconSVG } from "../../../../assets/SVGs/RevokeIconSVG";
import { TableSortingSVG } from "../../../../assets/SVGs/TableSortingSVG";
import { convertEpochtoDate } from "../../../../helper/DateConverters";
import { LEAVE_TYPES } from "../../../../util/constants";

export const dateBodyTemplate = (rowData: any, type: string) => {
  return (
    <span className="tw-flex tw-items-center tw-gap-2">
      <span className="tw-text-[#64748B] tw-text-sm">
        {type === "startDate" ? (
          <span>
            {rowData.startDate ? convertEpochtoDate(rowData.startDate) : ""}
          </span>
        ) : (
          <span>
            {rowData.endDate ? convertEpochtoDate(rowData.endDate) : ""}
          </span>
        )}
      </span>
    </span>
  );
};

export const statusBodyTemplate = (
  rowData: any,
  handleEditLeave: any,
  setIsConfirmDialogOpen: any,
  setDeleteId: any,
  setRevokeId: any,
  setActionType: any,
  setShowManagerComments: any,
  setApproveRejectComments: any
) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <span className="a-badge tw-border-transparent">
        <span
          className={`dot ${
            rowData.status === "APPROVED"
              ? "tw-bg-[#34C759]"
              : rowData.status === "REJECTED"
              ? "bg-error"
              : rowData.status === "CANCELLED"
              ? "tw-bg-[#999999]"
              : rowData.status === "REVOKED"
              ? "tw-bg-[#FF9500]"
              : "tw-bg-[#007AFF]"
          }`}
        ></span>
        <span className="badge-value tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
          {rowData.status}
        </span>
      </span>
      <span className="tw-flex tw-gap-2 tw-items-center">
        {rowData.status === "APPROVED" && (
          <span
            className="tw-ml-2 tw-cursor-pointer"
            onClick={() => {
              setRevokeId(rowData.id);
              setActionType("revoke");
              setIsConfirmDialogOpen(true);
            }}
          >
            <RevokeIconSVG />
          </span>
        )}
        {rowData.status === "SUBMITTED" && (
          <span
            className="tw-ml-2 tw-cursor-pointer"
            onClick={() => handleEditLeave(rowData)}
          >
            <EditButtonSVG />
          </span>
        )}
        {rowData.status === "SUBMITTED" && (
          <span
            className="tw-cursor-pointer"
            onClick={() => {
              setDeleteId(rowData.id);
              setActionType("delete");
              setIsConfirmDialogOpen(true);
            }}
          >
            <DeleteIconSVG />
          </span>
        )}
      </span>
      {/* Additional Icon */}
      {(rowData.status === "APPROVED" || rowData.status === "REJECTED") &&
        rowData?.tLLeaveType?.leaveType !== LEAVE_TYPES.SICK_LEAVE &&
        // rowData?.tLLeaveType?.leaveType !== LEAVE_TYPES.ABSCENCE_LEAVE &&
        rowData?.hideComment === false && (
          <span
            className="tw-cursor-pointer tw-px-0 tw-py-1 tw-rounded"
            onClick={() => {
              setShowManagerComments(true);
              setApproveRejectComments(rowData?.manager_comment ?? null);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
            >
              <path
                opacity="0.2"
                d="M17.7666 9.99999C17.7668 11.3171 17.4201 12.6111 16.7614 13.7517C16.1027 14.8923 15.1552 15.8393 14.0143 16.4975C12.8734 17.1556 11.5792 17.5017 10.2621 17.5009C8.94496 17.5001 7.65126 17.1525 6.51113 16.493L3.59004 17.4672C3.47992 17.5039 3.36174 17.5092 3.24876 17.4826C3.13578 17.4559 3.03246 17.3983 2.95037 17.3162C2.86829 17.2341 2.81069 17.1308 2.78402 17.0178C2.75736 16.9049 2.76269 16.7867 2.79941 16.6766L3.77363 13.7555C3.19778 12.7594 2.8588 11.6442 2.78293 10.4962C2.70706 9.3482 2.89632 8.19811 3.33608 7.13494C3.77583 6.07178 4.4543 5.12404 5.31897 4.36505C6.18363 3.60607 7.21133 3.05619 8.32253 2.75796C9.43373 2.45973 10.5987 2.42115 11.7272 2.64521C12.8556 2.86926 13.9175 3.34994 14.8305 4.05005C15.7435 4.75016 16.4831 5.65094 16.9923 6.68268C17.5014 7.71442 17.7664 8.84947 17.7666 9.99999Z"
                fill="black"
              />
              <path
                d="M10.2667 1.875C8.8639 1.87469 7.48496 2.23757 6.26405 2.9283C5.04314 3.61904 4.02186 4.6141 3.29961 5.81664C2.57737 7.01918 2.17876 8.38822 2.14259 9.79052C2.10643 11.1928 2.43393 12.5806 3.09323 13.8188L2.20651 16.4789C2.13306 16.6992 2.1224 16.9355 2.17573 17.1615C2.22905 17.3874 2.34426 17.5941 2.50842 17.7582C2.67259 17.9224 2.87924 18.0376 3.1052 18.0909C3.33117 18.1443 3.56751 18.1336 3.78776 18.0602L6.44792 17.1734C7.53758 17.753 8.74496 18.0767 9.97841 18.12C11.2119 18.1633 12.439 17.925 13.5666 17.4232C14.6942 16.9215 15.6926 16.1694 16.4862 15.2241C17.2798 14.2789 17.8475 13.1652 18.1465 11.9678C18.4454 10.7703 18.4675 9.52047 18.2113 8.31315C17.9551 7.10584 17.4271 5.97276 16.6676 4.99993C15.9081 4.02711 14.9369 3.24009 13.8278 2.69864C12.7187 2.15718 11.5009 1.87551 10.2667 1.875ZM10.2667 16.875C9.05805 16.8758 7.87065 16.5575 6.82448 15.9523C6.72953 15.8973 6.62175 15.8682 6.51198 15.868C6.44474 15.868 6.37796 15.8791 6.31432 15.9008L3.39167 16.875L4.36588 13.9531C4.39397 13.8692 4.40389 13.7802 4.395 13.6921C4.38611 13.604 4.35861 13.5188 4.31432 13.4422C3.55649 12.132 3.25222 10.6083 3.44872 9.10747C3.64522 7.60667 4.3315 6.21267 5.40111 5.14171C6.47071 4.07076 7.86385 3.38271 9.3644 3.18431C10.8649 2.98592 12.389 3.28826 13.7002 4.04444C15.0114 4.80062 16.0364 5.96837 16.6162 7.36652C17.196 8.76468 17.2981 10.3151 16.9068 11.7773C16.5156 13.2394 15.6527 14.5316 14.4521 15.4533C13.2515 16.375 11.7803 16.8748 10.2667 16.875ZM11.2042 10C11.2042 10.1854 11.1492 10.3667 11.0462 10.5208C10.9432 10.675 10.7967 10.7952 10.6254 10.8661C10.4541 10.9371 10.2656 10.9557 10.0838 10.9195C9.90191 10.8833 9.73486 10.794 9.60375 10.6629C9.47264 10.5318 9.38335 10.3648 9.34718 10.1829C9.31101 10.001 9.32957 9.81254 9.40053 9.64123C9.47149 9.46993 9.59165 9.32351 9.74582 9.2205C9.89999 9.11748 10.0812 9.0625 10.2667 9.0625C10.5153 9.0625 10.7538 9.16127 10.9296 9.33709C11.1054 9.5129 11.2042 9.75136 11.2042 10ZM7.76667 10C7.76667 10.1854 7.71168 10.3667 7.60867 10.5208C7.50565 10.675 7.35924 10.7952 7.18793 10.8661C7.01663 10.9371 6.82813 10.9557 6.64627 10.9195C6.46441 10.8833 6.29736 10.794 6.16625 10.6629C6.03514 10.5318 5.94585 10.3648 5.90968 10.1829C5.87351 10.001 5.89207 9.81254 5.96303 9.64123C6.03399 9.46993 6.15415 9.32351 6.30832 9.2205C6.46249 9.11748 6.64375 9.0625 6.82917 9.0625C7.07781 9.0625 7.31626 9.16127 7.49208 9.33709C7.66789 9.5129 7.76667 9.75136 7.76667 10ZM14.6417 10C14.6417 10.1854 14.5867 10.3667 14.4837 10.5208C14.3807 10.675 14.2342 10.7952 14.0629 10.8661C13.8916 10.9371 13.7031 10.9557 13.5213 10.9195C13.3394 10.8833 13.1724 10.794 13.0413 10.6629C12.9101 10.5318 12.8209 10.3648 12.7847 10.1829C12.7485 10.001 12.7671 9.81254 12.838 9.64123C12.909 9.46993 13.0291 9.32351 13.1833 9.2205C13.3375 9.11748 13.5187 9.0625 13.7042 9.0625C13.9528 9.0625 14.1913 9.16127 14.3671 9.33709C14.5429 9.5129 14.6417 9.75136 14.6417 10Z"
                fill="black"
              />
            </svg>
          </span>
        )}
    </div>
  );
};

export const tableHeaderTemplate = (
  header: string,
  field: string,
  setSortFilter?: any
) => {
  return (
    <div
      className={`tw-flex tw-justify-between tw-w-full tw-items-center ${
        field !== "" && "tw-cursor-pointer"
      }`}
      onClick={() => {
        if (field !== "") {
          setSortFilter((prevSortFilter: any) => ({
            ...prevSortFilter,
            sortField: field,
            sortOrder: !prevSortFilter.sortOrder,
          }));
        }
      }}
    >
      <span className="tw-font-bold tw-text-[#141414]">{header}</span>
      {field !== "" && (
        <span className="tw-ml-4 tw-mr-0">
          <TableSortingSVG />
        </span>
      )}
    </div>
  );
};

export const emptyMessageTemplate = (
  <div style={{ textAlign: "center", fontSize: "1.25rem" }}>
    <h4>No records found.</h4>
  </div>
);

export const accordianHeaderTemplate = (rowData: any) => {
  return (
    <span className="tw-inline-flex tw-justify-between tw-items-center tw-gap-4 table-row-group-header">
      <span className="tw-inline-flex tw-flex-col">
        <span className="tw-text-black tw-font-bold tw-text-sm">
          {rowData?.displayName}
        </span>
        <div className="tw-flex tw-gap-3">
          <span className="tw-mr-2 tw-text-[#64748B] tw-text-">
            <span className="tw-font-semibold tw-text-[#64748B]">
              Available Leaves :
            </span>{" "}
            <span className="tw-text-[#00AFEE]">
              {rowData?.tLUserLeaveMapping?.available_leaves}
            </span>
          </span>
          <span className="tw-mr-2 tw-text-[#64748B] tw-text-">
            <span className="tw-font-semibold tw-text-[#64748B]">
              Used Leaves :
            </span>{" "}
            <span className="tw-text-[#00AFEE]">
              {rowData?.tLUserLeaveMapping?.used_leaves}
            </span>
          </span>
          <span className="tw-mr-2 tw-text-[#64748B] tw-text-">
            <span className="tw-font-semibold tw-text-[#64748B]">
              Pending Leaves :
            </span>{" "}
            <span className="tw-text-[#00AFEE]">
              {rowData?.tLUserLeaveMapping?.pending_leave ?? "N/A"}
            </span>
          </span>
          <span className="tw-mr-2 tw-text-[#64748B] tw-text-">
            <span className="tw-font-semibold tw-text-[#64748B]">
              Statutory Holidays :
            </span>{" "}
            <span className="tw-text-[#00AFEE]">
              {rowData?.tLUserLeaveMapping?.holiday_count}
            </span>
          </span>
        </div>
      </span>
    </span>
  );
};

export const totalLeavesBodyTemplate = (rowData: any) => {
  return (
    <span className="tw-flex tw-items-center tw-gap-2">
      <span className="tw-text-[#64748B] tw-text-sm">
        {rowData.totalLeaveDays} {rowData.totalLeaveDays > 1 ? "days" : "day"}
      </span>
    </span>
  );
};

export const descriptionBodyTemplate = (rowData: any) => {
  return (
    <span className="tw-flex tw-items-center tw-gap-2">
      <span className="tw-text-[#64748B] tw-text-sm">
        {rowData.description}
      </span>
    </span>
  );
};

export const statusBodyTemplateTeamLeaves = (
  rowData: any,
  setLeaveHistoryID: any,
  setIsApproveReject: any,
  setApproveRejectViewType: any,
  setShowManagerComments: any,
  setApproveRejectComments: any
) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <span className="a-badge tw-border-transparent">
        <span
          className={`dot ${
            rowData.status === "APPROVED"
              ? "tw-bg-[#34C759]"
              : rowData.status === "REJECTED"
              ? "bg-error"
              : rowData.status === "PENDING"
              ? "tw-bg-yellow-500"
              : rowData.status === "CANCELLED"
              ? "tw-bg-[#999999]"
              : rowData.status === "REVOKED"
              ? "tw-bg-[#FF9500]"
              : "tw-bg-[#007AFF]"
          }`}
        ></span>
        <span className="badge-value tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
          {rowData.status}
        </span>
      </span>
      <span className="tw-flex tw-gap-2 tw-items-center"></span>
      {rowData.status === "SUBMITTED" &&
        rowData?.lineManagerID?.toString() ===
          localStorage.userID.toString() && (
          <div className="tw-flex tw-gap-2 tw-justify-end">
            <span
              onClick={() => {
                setLeaveHistoryID(rowData.id);
                setIsApproveReject(true);
                setApproveRejectViewType("approve");
              }}
              className="tw-cursor-pointer"
            >
              <ApproveTimeLogIconSVG />
            </span>
            <span
              onClick={() => {
                setLeaveHistoryID(rowData.id);
                setIsApproveReject(true);
                setApproveRejectViewType("reject");
              }}
              className="tw-cursor-pointer"
            >
              <RejectTimeLogIconSVG />
            </span>
          </div>
        )}
      {/* Additional Icon */}
      {(rowData.status === "APPROVED" || rowData.status === "REJECTED") &&
        // rowData?.tLLeaveType?.leaveType !== LEAVE_TYPES.ABSCENCE_LEAVE &&
        rowData?.tLLeaveType?.leaveType !== LEAVE_TYPES.SICK_LEAVE && (
          <span
            className="tw-cursor-pointer tw-px-0 tw-py-1 tw-rounded"
            onClick={() => {
              setShowManagerComments(true);
              setApproveRejectComments(rowData?.manager_comment ?? null);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
            >
              <path
                opacity="0.2"
                d="M17.7666 9.99999C17.7668 11.3171 17.4201 12.6111 16.7614 13.7517C16.1027 14.8923 15.1552 15.8393 14.0143 16.4975C12.8734 17.1556 11.5792 17.5017 10.2621 17.5009C8.94496 17.5001 7.65126 17.1525 6.51113 16.493L3.59004 17.4672C3.47992 17.5039 3.36174 17.5092 3.24876 17.4826C3.13578 17.4559 3.03246 17.3983 2.95037 17.3162C2.86829 17.2341 2.81069 17.1308 2.78402 17.0178C2.75736 16.9049 2.76269 16.7867 2.79941 16.6766L3.77363 13.7555C3.19778 12.7594 2.8588 11.6442 2.78293 10.4962C2.70706 9.3482 2.89632 8.19811 3.33608 7.13494C3.77583 6.07178 4.4543 5.12404 5.31897 4.36505C6.18363 3.60607 7.21133 3.05619 8.32253 2.75796C9.43373 2.45973 10.5987 2.42115 11.7272 2.64521C12.8556 2.86926 13.9175 3.34994 14.8305 4.05005C15.7435 4.75016 16.4831 5.65094 16.9923 6.68268C17.5014 7.71442 17.7664 8.84947 17.7666 9.99999Z"
                fill="black"
              />
              <path
                d="M10.2667 1.875C8.8639 1.87469 7.48496 2.23757 6.26405 2.9283C5.04314 3.61904 4.02186 4.6141 3.29961 5.81664C2.57737 7.01918 2.17876 8.38822 2.14259 9.79052C2.10643 11.1928 2.43393 12.5806 3.09323 13.8188L2.20651 16.4789C2.13306 16.6992 2.1224 16.9355 2.17573 17.1615C2.22905 17.3874 2.34426 17.5941 2.50842 17.7582C2.67259 17.9224 2.87924 18.0376 3.1052 18.0909C3.33117 18.1443 3.56751 18.1336 3.78776 18.0602L6.44792 17.1734C7.53758 17.753 8.74496 18.0767 9.97841 18.12C11.2119 18.1633 12.439 17.925 13.5666 17.4232C14.6942 16.9215 15.6926 16.1694 16.4862 15.2241C17.2798 14.2789 17.8475 13.1652 18.1465 11.9678C18.4454 10.7703 18.4675 9.52047 18.2113 8.31315C17.9551 7.10584 17.4271 5.97276 16.6676 4.99993C15.9081 4.02711 14.9369 3.24009 13.8278 2.69864C12.7187 2.15718 11.5009 1.87551 10.2667 1.875ZM10.2667 16.875C9.05805 16.8758 7.87065 16.5575 6.82448 15.9523C6.72953 15.8973 6.62175 15.8682 6.51198 15.868C6.44474 15.868 6.37796 15.8791 6.31432 15.9008L3.39167 16.875L4.36588 13.9531C4.39397 13.8692 4.40389 13.7802 4.395 13.6921C4.38611 13.604 4.35861 13.5188 4.31432 13.4422C3.55649 12.132 3.25222 10.6083 3.44872 9.10747C3.64522 7.60667 4.3315 6.21267 5.40111 5.14171C6.47071 4.07076 7.86385 3.38271 9.3644 3.18431C10.8649 2.98592 12.389 3.28826 13.7002 4.04444C15.0114 4.80062 16.0364 5.96837 16.6162 7.36652C17.196 8.76468 17.2981 10.3151 16.9068 11.7773C16.5156 13.2394 15.6527 14.5316 14.4521 15.4533C13.2515 16.375 11.7803 16.8748 10.2667 16.875ZM11.2042 10C11.2042 10.1854 11.1492 10.3667 11.0462 10.5208C10.9432 10.675 10.7967 10.7952 10.6254 10.8661C10.4541 10.9371 10.2656 10.9557 10.0838 10.9195C9.90191 10.8833 9.73486 10.794 9.60375 10.6629C9.47264 10.5318 9.38335 10.3648 9.34718 10.1829C9.31101 10.001 9.32957 9.81254 9.40053 9.64123C9.47149 9.46993 9.59165 9.32351 9.74582 9.2205C9.89999 9.11748 10.0812 9.0625 10.2667 9.0625C10.5153 9.0625 10.7538 9.16127 10.9296 9.33709C11.1054 9.5129 11.2042 9.75136 11.2042 10ZM7.76667 10C7.76667 10.1854 7.71168 10.3667 7.60867 10.5208C7.50565 10.675 7.35924 10.7952 7.18793 10.8661C7.01663 10.9371 6.82813 10.9557 6.64627 10.9195C6.46441 10.8833 6.29736 10.794 6.16625 10.6629C6.03514 10.5318 5.94585 10.3648 5.90968 10.1829C5.87351 10.001 5.89207 9.81254 5.96303 9.64123C6.03399 9.46993 6.15415 9.32351 6.30832 9.2205C6.46249 9.11748 6.64375 9.0625 6.82917 9.0625C7.07781 9.0625 7.31626 9.16127 7.49208 9.33709C7.66789 9.5129 7.76667 9.75136 7.76667 10ZM14.6417 10C14.6417 10.1854 14.5867 10.3667 14.4837 10.5208C14.3807 10.675 14.2342 10.7952 14.0629 10.8661C13.8916 10.9371 13.7031 10.9557 13.5213 10.9195C13.3394 10.8833 13.1724 10.794 13.0413 10.6629C12.9101 10.5318 12.8209 10.3648 12.7847 10.1829C12.7485 10.001 12.7671 9.81254 12.838 9.64123C12.909 9.46993 13.0291 9.32351 13.1833 9.2205C13.3375 9.11748 13.5187 9.0625 13.7042 9.0625C13.9528 9.0625 14.1913 9.16127 14.3671 9.33709C14.5429 9.5129 14.6417 9.75136 14.6417 10Z"
                fill="black"
              />
            </svg>
          </span>
        )}
    </div>
  );
};
